import { SavedReportsCard } from "@/Features/SavedReports";
import { saveAcquisitionReport } from "../../../../api";

export const SavedReports = ({ reportInfo }) => (
  <SavedReportsCard
    reportInfo={reportInfo}
    saveReport={saveAcquisitionReport}
  />
);

export default SavedReports;
